export default __webpack_public_path__ + "static/media/01.1063ea1e.jpg";